<br>
<br>
<div style="margin:auto; width:350px; text-align: center;">
  <img class="logo" src="{{glob.host}}filer/logo_login">
  <br>
  <br>
  <h5 class="text-primary">{{glob.config.title}}</h5>
  <label>{{glob.config.co}}</label>
  <br><br>
  <table>
    <tr>
      <td>
        <span class="user_name_label disabled nav-link">{{glob.config.user_name_label}}</span>
      </td>
      <td>
        <span class="password_label disabled nav-link">{{glob.config.password_label}}</span>
      </td>
    </tr>
    <tr>
      <td>
        <div class="form-floating" id="user_name_pad">
          <input type="text" id="user_name" [(ngModel)]="user_name" name="user_name" class="form-control" placeholder="کاربر" (keydown)="onKeydown($event)">
          <label for="user_name">نام کاربری</label>
        </div>
      </td>
      <td>
        <div class="form-floating" id="password_pad">
          <input type="password" id="password" [(ngModel)]="password" name="password" class="form-control" placeholder="رمز عبور" (keydown)="onKeydown($event)">
          <label for="password">رمز عبور</label>
        </div>
      </td>
    </tr>
    <tr>
      <td colspan="2">
        <button type="button" id="login" class="btn" (click)="login()">ورود به سامانه</button>
      </td>
    </tr>
    <tr>
      <td style="text-align: center;">
        <a id="recoveryPassword" title="فراموشی رمز عبور" class="nav-link" routerlink="/account/recovery_password"><i class="bi bi-magic"></i> بازیابی رمز عبور</a>
      </td>
      <td>

        <a id="recoveryPassword" title="ثبت نام" class="disabled nav-link" routerlink="/account/register"><i class="bi bi-person-plus-fill"></i> ایجاد حساب کاربری</a>
      </td>
    </tr>
  </table>
  <span class="disabled nav-link">
    .:. {{glob.config.owner}} .:. <br>

  </span>
  <br>
  <br>


  <div class="social">
    <i class="bi bi-google"></i>
    <i class="bi bi-twitter"></i>
    <i class="bi bi-linkedin"></i>
    <i class="bi bi-whatsapp"></i>
    <i class="bi bi-instagram"></i>
  </div>
  <hr>
  <span class="text-muted" style="display: none;">..... طراحی و توسعه سامانه توسط <a href="http://padira.ir">پدیرا</a> .....</span>
</div>